<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn :disabled="disabled" icon small @click="ActionButton">
                <v-icon :color="color" dark v-bind="attrs" v-on="on">
                    {{ icon }}
                </v-icon>
            </v-btn>
        </template>
        <span>{{ tip }}</span>
    </v-tooltip>
</template>
<script>
export default {
    props: {
        icon: {
            type: String,
            require: true
        },
        tip: {
            type: String
        },
        color: {
            type: String
        },
        disabled: {
            type: Boolean
        }
    },
    methods: {
        ActionButton() {
            this.$emit('ActionButton')
        }
    }
}
</script>
<style scoped></style>
